<template>
  <div>
    <b-container>
      <PlugIn></PlugIn>
    </b-container>
  </div>
</template>

<script>
import PlugIn from '@/components/PlugIn.vue';


export default {
  name: 'PlugInPage',
  components: {
    PlugIn
  }
}
</script>
